import { render, staticRenderFns } from "./IconSqFeet.vue?vue&type=template&id=53b097f8&"
import script from "./IconSqFeet.vue?vue&type=script&lang=js&"
export * from "./IconSqFeet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports